/**
 * Titanoré stack discount — shared calculator + cart UI.
 * Shopify allocations are truth. This file paints expectation until a
 * real discount engine (Function/app) applies the same amounts.
 */
(function () {
  "use strict";
  if (window.TLStack && window.TLStack.__booted) return;

  var cfg = window.TL_STACK || {};
  var PCT2 = Number(cfg.pct2 != null ? cfg.pct2 : 10);
  var PCT3 = Number(cfg.pct3 != null ? cfg.pct3 : 15);
  var PARTICIPANTS = String(cfg.handles || "")
    .toLowerCase()
    .split(",")
    .map(function (s) { return s.trim(); })
    .filter(Boolean);
  var EXCLUDED = String(cfg.exclude || "titanore-titanium-cookbook,the-titanium-table,order-protection")
    .toLowerCase()
    .split(",")
    .map(function (s) { return s.trim(); })
    .filter(Boolean);
  var EXCLUDE_TYPES = ["verzendverzekering", "gift card", "giftcard", "service"];
  var moneyFmt = cfg.moneyFormat || "€{{amount}}";

  function money(cents) {
    var n = Math.round(Number(cents) || 0);
    var neg = n < 0;
    n = Math.abs(n);
    var euros = (n / 100).toFixed(2).replace(".", ",");
    var out = moneyFmt
      .replace("{{amount_with_comma_separator}}", euros)
      .replace("{{amount}}", euros);
    if (out.indexOf("{{") !== -1) out = "€" + euros;
    return neg ? "−" + out : out;
  }

  function isExcludedLine(line) {
    var handle = String((line.product && line.product.handle) || line.handle || "").toLowerCase();
    var type = String((line.product && line.product.type) || line.product_type || "").toLowerCase();
    var title = String(line.product_title || (line.product && line.product.title) || "").toLowerCase();
    var price = Number(line.final_price != null ? line.final_price : line.price) || 0;
    if (EXCLUDED.indexOf(handle) !== -1) return true;
    if (EXCLUDE_TYPES.indexOf(type) !== -1) return true;
    if (price <= 0) return true;
    if (title.indexOf("verzekering") !== -1 || title.indexOf("insurance") !== -1) return true;
    if (title.indexOf("cadeaubon") !== -1 || title.indexOf("gift card") !== -1) return true;
    if (handle.indexOf("cookbook") !== -1 || handle.indexOf("titanium-table") !== -1) return true;
    var props = line.properties || {};
    if (props._gift || props._is_free_gift === "true" || props._free_gift === "true") return true;
    return false;
  }

  function isParticipant(line) {
    if (isExcludedLine(line)) return false;
    var handle = String((line.product && line.product.handle) || line.handle || "").toLowerCase();
    if (!handle) return false;
    if (PARTICIPANTS.length === 0) return false;
    return PARTICIPANTS.indexOf(handle) !== -1;
  }

  function unitPrice(line) {
    var qty = Number(line.quantity) || 1;
    var finalLine = Number(line.final_line_price != null ? line.final_line_price : line.line_price);
    if (finalLine > 0 && qty > 0) return Math.round(finalLine / qty);
    return Number(line.final_price != null ? line.final_price : line.price) || 0;
  }

  function shopifyStackAllocated(cart) {
    var total = 0;
    var lines = (cart && cart.items) || [];
    lines.forEach(function (line) {
      (line.discounts || line.line_level_discount_allocations || []).forEach(function (d) {
        var title = String(d.title || (d.discount_application && d.discount_application.title) || "").toLowerCase();
        if (title.indexOf("stapel") !== -1 || title.indexOf("stack") !== -1) {
          total += Number(d.amount != null ? d.amount : d.total_allocated_amount) || 0;
        }
      });
    });
    (cart.cart_level_discount_applications || []).forEach(function (d) {
      var title = String(d.title || "").toLowerCase();
      if (title.indexOf("stapel") !== -1 || title.indexOf("stack") !== -1) {
        total += Number(d.total_allocated_amount) || 0;
      }
    });
    return total;
  }

  function compute(cart) {
    var items = (cart && cart.items) || [];
    var units = [];
    items.forEach(function (line, lineIndex) {
      var qty = Number(line.quantity) || 0;
      var handle = String((line.product && line.product.handle) || line.handle || "").toLowerCase();
      if (!handle && line.url) {
        var m = String(line.url).match(/\/products\/([^/?#]+)/);
        if (m) handle = m[1].toLowerCase();
      }
      line.handle = handle;
      var part = isParticipant(line);
      var price = unitPrice(line);
      var vid = String(line.variant_id || (line.variant && line.variant.id) || "");
      for (var i = 0; i < qty; i++) {
        units.push({
          lineIndex: lineIndex,
          unitIndex: i,
          key: line.key,
          handle: handle,
          variantId: vid,
          title: line.product_title || line.title,
          price: price,
          participant: part,
          excluded: isExcludedLine(line)
        });
      }
    });

    var parts = units.filter(function (u) { return u.participant; });
    parts.sort(function (a, b) {
      if (b.price !== a.price) return b.price - a.price;
      if (a.variantId !== b.variantId) return a.variantId < b.variantId ? -1 : 1;
      if (a.unitIndex !== b.unitIndex) return a.unitIndex - b.unitIndex;
      return a.lineIndex - b.lineIndex;
    });

    var byLine = {};
    var extra = 0;
    parts.forEach(function (u, idx) {
      var pct = 0;
      if (idx === 1) pct = PCT2;
      else if (idx >= 2) pct = PCT3;
      u.rank = idx + 1;
      u.pct = pct;
      u.discount = Math.round((u.price * pct) / 100);
      extra += u.discount;
      if (!byLine[u.key]) {
        byLine[u.key] = { key: u.key, handle: u.handle, title: u.title, qty: 0, base: 0, discount: 0, units: [] };
      }
      byLine[u.key].qty += 1;
      byLine[u.key].base += u.price;
      byLine[u.key].discount += u.discount;
      byLine[u.key].units.push(u);
    });

    var applied = shopifyStackAllocated(cart);
    return {
      units: parts,
      byLine: byLine,
      extra: extra,
      applied: applied,
      participantCount: parts.length,
      subtotal: Number(cart.items_subtotal_price != null ? cart.items_subtotal_price : cart.total_price) || 0,
      total: Number(cart.total_price) || 0
    };
  }

  function upsellDelta(cart, addPriceCents) {
    var now = compute(cart);
    var clone = JSON.parse(JSON.stringify(cart));
    clone.items = (clone.items || []).concat([{
      quantity: 1,
      price: addPriceCents,
      final_price: addPriceCents,
      final_line_price: addPriceCents,
      handle: "__upsell_probe__",
      product: { handle: PARTICIPANTS[0] || "chefs-pan-set-3" },
      variant_id: "99999999999999",
      key: "__upsell_probe__",
      product_title: "probe"
    }]);
    if (PARTICIPANTS.indexOf("__upsell_probe__") === -1) {
      /* probe uses first participant handle so it counts */
    }
    var next = compute(clone);
    return next.extra - now.extra;
  }

  function ensurePanel() {
    if (window.TL_TIER) return document.querySelectorAll("[data-tl-stack-cart]");
    var roots = document.querySelectorAll("[data-tl-stack-cart]");
    if (roots.length) return roots;
    var host = document.querySelector(".tl-cart-fase1__summary, .tl-summary, [data-tl-summary], .cart__footer, .drawer__footer");
    if (!host) return [];
    var el = document.createElement("div");
    el.className = "tl-stack-cart";
    el.setAttribute("data-tl-stack-cart", "");
    el.innerHTML =
      '<p class="tl-stack-cart__kicker">Stapelkorting</p>' +
      '<p class="tl-stack-cart__rule">' + PCT2 + "% extra op je tweede artikel. " + PCT3 + "% extra op je derde en volgende.</p>" +
      '<p class="tl-stack-cart__fine">Op geselecteerde artikelen, ook op actieprijzen. Het duurste deelnemende artikel krijgt geen extra korting. Een set telt als één artikel.</p>' +
      '<div class="tl-stack-cart__rows">' +
      '<div class="tl-stack-cart__row"><span>Verwachte stapelkorting</span><span data-tl-stack-expect>—</span></div>' +
      '<div class="tl-stack-cart__row"><span>Door Shopify toegepast</span><span data-tl-stack-applied>—</span></div>' +
      '<div class="tl-stack-cart__row tl-stack-cart__row--extra"><span>Totaal extra voordeel (verwachting)</span><strong data-tl-stack-extra>—</strong></div>' +
      "</div>" +
      '<div class="tl-stack-lines" data-tl-stack-lines></div>' +
      '<p class="tl-stack-cart__state" data-tl-stack-state></p>';
    host.insertBefore(el, host.firstChild);
    return document.querySelectorAll("[data-tl-stack-cart]");
  }

  function render(result, cart) {
    var roots = ensurePanel();
    if (!roots.length) return;
    roots.forEach(function (root) {
      root.classList.remove("is-loading");
      var extraEl = root.querySelector("[data-tl-stack-extra]");
      var appliedEl = root.querySelector("[data-tl-stack-applied]");
      var expectEl = root.querySelector("[data-tl-stack-expect]");
      var stateEl = root.querySelector("[data-tl-stack-state]");
      var listEl = root.querySelector("[data-tl-stack-lines]");
      var hintEl = root.querySelector("[data-tl-stack-hint]");
      if (extraEl) extraEl.textContent = money(result.extra);
      if (expectEl) expectEl.textContent = money(result.extra);
      if (appliedEl) appliedEl.textContent = money(result.applied);
      if (stateEl) {
        if (result.participantCount < 2) {
          stateEl.textContent = "Nog geen extra stapelkorting — voeg een tweede geselecteerd artikel toe.";
        } else if (result.applied > 0 && Math.abs(result.applied - result.extra) <= 1) {
          stateEl.textContent = "Stapelkorting is toegepast in Shopify.";
        } else if (result.applied > 0) {
          stateEl.textContent = "Shopify paste €-korting toe; verwacht bedrag kan afwijken. Checkout is leidend.";
        } else {
          stateEl.textContent = "Verwachting — Shopify heeft deze stapelkorting nog niet toegepast in checkout.";
        }
      }
      if (listEl) {
        var html = "";
        Object.keys(result.byLine).forEach(function (key) {
          var row = result.byLine[key];
          var bits = row.units.map(function (u) {
            if (!u.pct) return "1× geen extra";
            return "1× −" + u.pct + "% (" + money(u.discount) + ")";
          }).join(" · ");
          html += '<div class="tl-stack-line"><span>' + escapeHtml(row.title) + '</span><span>' + bits + '</span></div>';
        });
        listEl.innerHTML = html;
      }
      if (hintEl) {
        if (result.participantCount === 1) {
          hintEl.hidden = false;
        } else {
          hintEl.hidden = result.participantCount === 0;
        }
      }
      root.setAttribute("data-tl-stack-extra-cents", String(result.extra));
      root.setAttribute("data-tl-stack-applied-cents", String(result.applied));
      root.setAttribute("data-tl-stack-count", String(result.participantCount));
    });

    document.querySelectorAll("[data-tl-stack-upsell]").forEach(function (el) {
      var add = Number(el.getAttribute("data-tl-stack-add-cents") || 0);
      if (!add) return;
      var delta = upsellDelta(cart, add);
      var out = el.querySelector("[data-tl-stack-upsell-amount]");
      if (delta > 0) {
        el.hidden = false;
        if (out) out.textContent = money(delta);
      } else {
        el.hidden = true;
      }
    });
  }

  function escapeHtml(s) {
    return String(s || "")
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;");
  }

  function setLoading(on) {
    document.querySelectorAll("[data-tl-stack-cart]").forEach(function (root) {
      root.classList.toggle("is-loading", !!on);
    });
  }

  var lastCart = null;
  function refresh() {
    setLoading(true);
    return fetch("/cart.js", { credentials: "same-origin" })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        lastCart = cart;
        var result = compute(cart);
        render(result, cart);
        window.TLStack.last = result;
        window.TLStack.lastCart = cart;
        setLoading(false);
        return result;
      })
      .catch(function () { setLoading(false); });
  }

  function hookCart() {
    var orig = window.fetch;
    if (orig && !orig.__tlStack) {
      window.fetch = function (input, init) {
        var p = orig.apply(this, arguments);
        try {
          var url = typeof input === "string" ? input : (input && input.url) || "";
          if (/\/cart\//.test(url) || /\/change\.js/.test(url) || /\/add\.js/.test(url) || /\/update\.js/.test(url) || /\/clear\.js/.test(url)) {
            p.then(function () { setTimeout(refresh, 80); }).catch(function () {});
          }
        } catch (e) {}
        return p;
      };
      window.fetch.__tlStack = true;
    }
    document.addEventListener("cart:updated", refresh);
    document.addEventListener("ajaxCart:updated", refresh);
    document.addEventListener("theme:cart:change", refresh);
  }

  window.TLStack = {
    __booted: true,
    compute: compute,
    refresh: refresh,
    money: money,
    isParticipant: isParticipant,
    cfg: { pct2: PCT2, pct3: PCT3, handles: PARTICIPANTS, exclude: EXCLUDED }
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      hookCart();
      refresh();
    });
  } else {
    hookCart();
    refresh();
  }
})();
